import Heart from '../../Heart';
import Furniture from './Furniture';

const STATE_SPAWN = 1;
const STATE_RETURN = 2;

export default class BeeTree extends Furniture {
  constructor({ game, location, data }) {
    super({ game, location, data });

    //
    this.bees = [];
    this.beesPool = [];
    this.targetIDs = [0, 1, 2]; // ids of available targets
    this.targets = [
      { x: -156, y: -102 },
      { x: -198, y: -183 },
      { x: -233, y: -122 },
    ];
    this.beeStart = { x: -28, y: -300 };
    this.honey = 0;

    this.state = STATE_SPAWN;

    //
    this.hiveBone = this.asset.skeleton.findBone('hive');

    //
    this.asset.onEvent.add(this.handleAudioEvent, this);

    //
    this.setAnim('1_idle');
  }

  updateBounds() {
    this.bb = this.getBounds();
    this.bb.height = 420;
  }

  setNight() {
    // return bees home
    for (let i = 0; i < this.bees.length; i++) {
      this.bees[i].returnHome();
    }
  }

  /* ----------------------------------------------------------------------- */
  // BEES
  /* ----------------------------------------------------------------------- */
  handleInputDown() {
    if (this.location.isDay()) {
      if (this.state === STATE_SPAWN) {
        // spawn bee
        const targetId = Phaser.ArrayUtils.removeRandomItem(this.targetIDs);
        this.spawnBee(targetId);
      } else {
        // return bee home
        for (let i = 0; i < this.bees.length; i++) {
          if (this.bees[i].onFlower) {
            this.bees[i].returnHome();
            break;
          }
        }
      }
    }
  }

  spawnBee(targetId) {
    const x = this.x + this.beeStart.x;
    const y = this.y + this.beeStart.y;

    let bee;
    if (this.beesPool.length > 0) {
      bee = this.beesPool.shift();
    } else {
      bee = this.location.addFurniture({ id: 'bee', x: x, y: y });
    }
    bee.init(x, y);
    const targetPos = this.targets[targetId];
    bee.setTarget({ x: this.x + targetPos.x, y: this.y + targetPos.y }, targetId);
    bee.beeTree = this;
    this.bees.push(bee);

    // play audio
    if (this.bees.length === 1) {
      this.ambience = this.game.sounds
        .playSFX('bee_loop', {
          spriteID: 'sfx',
          loop: true,
        })
        .get('bee_loop');
    }

    //
    if (this.bees.length === 3) {
      this.state = STATE_RETURN;
    }
  }

  removeBee(bee) {
    const ind = this.bees.indexOf(bee);
    if (ind > -1) {
      this.bees.splice(ind, 1);
      this.targetIDs.push(bee.targetId);
      bee.removeMe();
      this.beesPool.push(bee);
      // collect honey
      this.honey++;
      if (this.honey === 3) {
        this.honey = 0;
        this.setAnim('2_dripping', false, 1);
        // this.game.sounds.playSFX('item_honey', { spriteID: 'sfx' });
      }
    }

    // stop audio
    if (this.bees.length === 0) {
      this.ambience = null;
      this.game.sounds.stopAudioSprite('bee_loop', { spriteID: 'sfx' });

      // show heart
      const heart = new Heart(this.game, -30, -360);
      this.addChild(heart);

      //
      this.state = STATE_SPAWN;
    }

    //
    this.location.state.setLoopHint(this.data.hint);
  }

  handleAudioEvent(track, event) {
    track;
    this.game.sounds.playSFX(event.data.name, { spriteID: 'sfx' });
  }

  //
  pulse(time = 1500) {
    this.game.add
      .tween(this.hiveBone)
      .to({ scaleX: [1.2, 1, 1.2, 1, 1.2, 1], scaleY: [1.2, 1, 1.2, 1, 1.2, 1] }, time, null, true);
  }

  step(dt) {
    super.step(dt);

    if (this.ambience) {
      const left = -this.location.x;
      const right = left + this.game.width;
      const width = (right - left) * 0.5;
      const mid = (right + left) * 0.5;
      const x = this.x - 200;
      if (x < right && x > left) {
        this.ambience.volume = 1 - Math.abs(x - mid) / width;
      } else {
        this.ambience.volume = 0;
      }
    }
  }
}
